import React from 'react'
import { Stack } from 'react-bootstrap'
import type { FormikHelpers } from 'formik/dist/types'
import type { CustomerInfoFormProps, UseEditPersonInfoArgs } from '@ztechapps/webui.contract'
import { Form, FormSaveCancelButtons } from '@ztechapps/webui.form'
import { HorizontalStack } from '@ztechapps/webui.util'
import { CustomerFormLayout } from '../CustomerSelect/CustomerFormLayout'
import { useEditPersonInformation } from './useEditPersonInformation'

export const CustomerInfoForm = ({ customer, onSaved, onCancel, readOnlyCompany = false }: CustomerInfoFormProps) => {
  const { validate, onFormSubmit } = useEditPersonInformation()
  const initialValues: UseEditPersonInfoArgs = {
    _id: customer?._id,
    company: customer?.company,
    profile: customer?.profile,
    phone: customer?.phone,
  }

  // A failed save is toasted by the hook, so nothing runs after it and the form stays as entered.
  const onSubmit = async (values: UseEditPersonInfoArgs, formikHelpers: FormikHelpers<UseEditPersonInfoArgs>) => {
    if (await onFormSubmit(values, formikHelpers)) await onSaved?.(values)
  }

  return (
    <Form onSubmit={onSubmit} validate={validate} initialValues={initialValues} onReset={() => onCancel?.()}>
      <Stack gap={2}>
        <CustomerFormLayout readOnlyCompany={readOnlyCompany} />

        <HorizontalStack className="justify-content-end">
          <div>
            <FormSaveCancelButtons />
          </div>
        </HorizontalStack>
      </Stack>
    </Form>
  )
}
